/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для пользовательских данных в кабинете
   */
  app.UserDataView = app.View.extend({
    el: '#user-data',
    jsonUserPhones: '#json-user-phones',
    template: app.helpers.TemplateHelper.getTemplate('#user-phone-rows-view'),
    userPhoneTemplate: app.helpers.TemplateHelper.getTemplate('#user-phone-view'),
    userNameTemplate: app.helpers.TemplateHelper.getTemplate('#user-name-view'),
    plainEmail: '#plain_email',
    plainPhone: '#plain_phone',
    plainName: '.user-prof__greeting .h5',
    events: {
      'click .user-toggle': 'showFormUserData'
    },

    /**
     * @param boolean Успешно сохранены данные пользователя
     */
    successUserData: false,
    /**
     * @param boolean Успешно обновлены телефоны
     */
    successPhoneList: false,

    run: function (options) {
      if (options && options.user) {
        this.user = options.user;
      }

      var userDataForm;

      this.collection = new app.UserPhones();
      this.collection.reset(app.helpers.TemplateHelper.getJson($(this.jsonUserPhones)));

      userDataForm = new app.UserDataFormView({
        collection: this.collection,
        user: this.user,
      });
      userDataForm.on('success-user-data-form', this.render, this);
      userDataForm.on('cancel-user-data-form', this.toggle, this);
    },

    render: function () {
      this.$('#additional-phone-raws').html(this.template({models: this.collection.models}));
      this.$(this.plainEmail).text(app.user.get('email'));
      this.$(this.plainPhone).text(this.userPhoneTemplate({model: app.user}));
      this.$(this.plainName).text(this.userNameTemplate({model: app.user}));

      this.toggle();
    },
    /**
     * Показывает форму изменения личных данных пользователя
     */
    showFormUserData: function (e) {
      $(e.currentTarget).closest('.b-card').children('.b-section')
        .stop(true, true)
        .animate({
          height: 'toggle',
          opacity: 'toggle'
        }, 500);
    }
  });
})(jQuery);

}.call(window));